
import { v4 as uuidv4 } from 'uuid';
import { Drawer } from '@mui/material';
import { useSelector } from 'react-redux';



export const LeftDrawer = () => {
  
  const { leftDrawer } = useSelector((state: any) => state.leftDrawer)

  return (
    <div key={ `LeftDrawer_${uuidv4()}` }>
      <Drawer open={leftDrawer?.show}>
      test content for drawer
      </Drawer>
    </div>
  );
};

export default LeftDrawer;
